// ─── SCROLL REVEAL (DYNAMIC) ───
const revealObserver = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      e.target.classList.add('visible');
      revealObserver.unobserve(e.target);
    }
  });
}, { threshold: 0.1 });

function initReveals(container = document) {
  const elements = container.querySelectorAll('.reveal');
  elements.forEach(el => revealObserver.observe(el));
}

// Initial observation
initReveals();

// MutationObserver to catch dynamically added content (AJAX Recommendations/Filters)
const domObserver = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (node.nodeType === 1) { // ELEMENT_NODE
        // If the node itself is a reveal element
        if (node.classList.contains('reveal')) {
          revealObserver.observe(node);
        }
        // Also check children
        initReveals(node);
      }
    });
  });
});

domObserver.observe(document.body, { childList: true, subtree: true });

// ─── STICKY NAV ───
const navbar = document.getElementById('navbar');
window.addEventListener('scroll', () => {
  if (window.scrollY > 60) {
    navbar.style.background = 'var(--bg-dark)';
    navbar.style.boxShadow = 'none';
  } else {
    navbar.style.background = 'var(--bg-dark)';
    navbar.style.boxShadow = 'none';
  }
});

// ─── FILTER BUTTONS ───
document.querySelectorAll('.filter-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
  });
});

// ─── STAT COUNTERS ───
function animateCounter(el, target, suffix) {
  let current = 0;
  const duration = 1800;
  // Handle case where target is not a straightforward number (e.g., '15' or '100')
  const targetNum = parseFloat(target) || 0;
  if(targetNum === 0) {
    el.innerHTML = target + '<span>' + (suffix || '') + '</span>';
    return;
  }
  const step = targetNum / (duration / 16);
  const timer = setInterval(() => {
    current += step;
    if (current >= targetNum) {
      current = targetNum;
      clearInterval(timer);
    }
    el.innerHTML = Math.floor(current) + '<span>' + (suffix || '') + '</span>';
  }, 16);
}

const statsObserver = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      const el = e.target;
      // Handle legacy hero stats (hardcoded order)
      if(el.classList.contains('hero-stats')) {
        const nums = el.querySelectorAll('.stat-number');
        if(nums.length >= 3) {
          animateCounter(nums[0], 15, '+');
          animateCounter(nums[1], 48, 'hr');
          animateCounter(nums[2], 100, '%');
        }
        statsObserver.unobserve(el);
      } 
      // Handle generic counters (About Hero, Stats Bar)
      else if (el.classList.contains('js-stat-counter')) {
        const target = el.getAttribute('data-target') || 0;
        const suffix = el.getAttribute('data-suffix') || '';
        animateCounter(el, target, suffix);
        statsObserver.unobserve(el);
      }
    }
  });
}, { threshold: 0.15 });

// Initialize observers on load
document.addEventListener('DOMContentLoaded', () => {
  // Observe legacy hero stats container
  const heroStats = document.querySelector('.hero-stats');
  if (heroStats) statsObserver.observe(heroStats);

  // Observe new generic stat counters individually
  const statCounters = document.querySelectorAll('.js-stat-counter');
  statCounters.forEach(el => statsObserver.observe(el));
});

// ─── SET MIN DATES ───
const today = new Date().toISOString().split('T')[0];
document.querySelectorAll('input[type="date"]').forEach(inp => {
  inp.min = today;
  inp.value = '';
});

// ─── ACCORDION ───
document.querySelectorAll('.accordion-header').forEach(btn => {
  btn.addEventListener('click', () => {
    const item = btn.parentElement;
    const content = item.querySelector('.accordion-content');
    item.classList.toggle('active');
    if (item.classList.contains('active')) {
      content.style.maxHeight = content.scrollHeight + 'px';
      btn.setAttribute('aria-expanded', 'true');
    } else {
      content.style.maxHeight = '0';
      btn.setAttribute('aria-expanded', 'false');
    }
  });
});

// Initialize active accordions (Open by default)
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.accordion-item.active').forEach(item => {
    const content = item.querySelector('.accordion-content');
    if (content) {
      content.style.maxHeight = content.scrollHeight + 'px';
      const btn = item.querySelector('.accordion-header');
      if (btn) btn.setAttribute('aria-expanded', 'true');
    }
  });
});

// --- BUY IT NOW REDIRECT ---
document.addEventListener("submit", (e) => {
  const form = e.target;
  if (form.action && form.action.includes("/cart/add")) {
    const buyNowBtn = form.querySelector(".btn-buy-now");
    if (buyNowBtn && document.activeElement === buyNowBtn) {
      const returnInput = document.createElement("input");
      returnInput.type = "hidden";
      returnInput.name = "return_to";
      returnInput.value = "/checkout";
      form.appendChild(returnInput);
    }
  }
});

// --- COLLECTION FILTER DRAWER (DELEGATED) ---
document.addEventListener('click', (e) => {
  const openBtn = e.target.closest('#MobileFilterBtn');
  const closeBtn = e.target.closest('#FilterDrawerClose');
  const overlay = e.target.closest('#FilterDrawerOverlay');
  
  const sidebar = document.getElementById('FilterSidebar');
  const overlayEl = document.getElementById('FilterDrawerOverlay');

  if (openBtn) {
    if (sidebar) sidebar.classList.add('filter-drawer-open');
    if (overlayEl) overlayEl.classList.add('filter-drawer-open');
    document.body.style.overflow = 'hidden';
  }

  if (closeBtn || overlay) {
    if (sidebar) sidebar.classList.remove('filter-drawer-open');
    if (overlayEl) overlayEl.classList.remove('filter-drawer-open');
    document.body.style.overflow = '';
  }
});

/* --- MAIN PRODUCT PAGE LOGIC --- */
document.addEventListener("DOMContentLoaded", function() {
  const thumbs = document.querySelectorAll('.thumb-item');
  const mainImg = document.getElementById('MainProductImage');
  if (thumbs.length && mainImg) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        const img = thumb.querySelector('img');
        if (img) {
          const newSrc = img.src.replace('width=200', 'width=1200');
          mainImg.src = newSrc;
        }
      });
    });
  }

  const durationBtns = document.querySelectorAll('.duration-btn');
  const hiddenInput = document.getElementById('HireDurationValue');
  if (durationBtns.length && hiddenInput) {
    durationBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        durationBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        hiddenInput.value = btn.getAttribute('data-variant-title');
      });
    });
  }
});
